import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/MetasComisiones.css';

const MetasComisiones = () => {
  const [metas, setMetas] = useState([]);
  const [comisiones, setComisiones] = useState([]);
  const [estadisticas, setEstadisticas] = useState(null);
  const [vista, setVista] = useState('dashboard'); // dashboard, metas, comisiones
  const [loading, setLoading] = useState(false);
  const [mostrarModalMeta, setMostrarModalMeta] = useState(false);
  const [cobradores, setCobradores] = useState([]);
  const [nuevaMeta, setNuevaMeta] = useState({
    cobrador_id: '',
    tipo: 'mensual',
    periodo_inicio: new Date().toISOString().split('T')[0],
    monto_objetivo: '',
    cantidad_cobros_objetivo: '',
    bono_cumplimiento: ''
  });

  useEffect(() => {
    cargarEstadisticas();
    cargarMetas();
    cargarComisiones();
    cargarCobradores();
  }, []);

  const cargarEstadisticas = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        '/metas/estadisticas',
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.success) {
        setEstadisticas(response.data.estadisticas);
      }
    } catch (error) {
      console.error('Error cargando estadísticas:', error);
    }
  };

  const cargarMetas = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/metas', {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        setMetas(response.data.metas);
      }
    } catch (error) {
      console.error('Error cargando metas:', error);
    } finally {
      setLoading(false);
    }
  };

  const cargarComisiones = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/comisiones', {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.success) {
        setComisiones(response.data.comisiones);
      }
    } catch (error) {
      console.error('Error cargando comisiones:', error);
    }
  };

  const cargarCobradores = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        '/permisos/usuarios?rol=cobrador',
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.data.usuarios) {
        setCobradores(response.data.usuarios);
      }
    } catch (error) {
      console.error('Error cargando cobradores:', error);
    }
  };

  const crearMeta = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        '/metas',
        nuevaMeta,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert('✅ Meta creada correctamente');
      setMostrarModalMeta(false);
      cargarMetas();
      cargarEstadisticas();
      setNuevaMeta({
        cobrador_id: '',
        tipo: 'mensual',
        periodo_inicio: new Date().toISOString().split('T')[0],
        monto_objetivo: '',
        cantidad_cobros_objetivo: '',
        bono_cumplimiento: ''
      });
    } catch (error) {
      alert('Error al crear meta');
      console.error(error);
    }
  };

  const actualizarProgreso = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        '/metas/actualizar-progreso',
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert('✅ Progreso actualizado');
      cargarMetas();
      cargarEstadisticas();
    } catch (error) {
      alert('Error al actualizar progreso');
      console.error(error);
    }
  };

  const calcularComisiones = async () => {
    if (!window.confirm('¿Calcular comisiones de pagos recientes?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post(
        '/comisiones/calcular',
        { porcentaje: 5.0 },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert('✅ Comisiones calculadas');
      cargarComisiones();
      cargarEstadisticas();
    } catch (error) {
      alert('Error al calcular comisiones');
      console.error(error);
    }
  };

  const pagarComision = async (comisionId) => {
    if (!window.confirm('¿Marcar esta comisión como pagada?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `window.location.origin/api/comisiones/${comisionId}/pagar`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      alert('✅ Comisión marcada como pagada');
      cargarComisiones();
      cargarEstadisticas();
    } catch (error) {
      alert('Error al marcar comisión');
      console.error(error);
    }
  };

  const getEstadoClass = (estado) => {
    return `estado-${estado}`;
  };

  const getProgresoColor = (porcentaje) => {
    if (porcentaje >= 100) return '#28a745';
    if (porcentaje >= 75) return '#ffc107';
    if (porcentaje >= 50) return '#ff9800';
    return '#dc3545';
  };

  return (
    <div className="metas-comisiones">
      <div className="page-header">
        <h1>🎯 Metas y Comisiones</h1>
        <div className="header-actions">
          <button className="btn-actualizar" onClick={actualizarProgreso}>
            🔄 Actualizar Progreso
          </button>
          <button className="btn-nueva-meta" onClick={() => setMostrarModalMeta(true)}>
            ➕ Nueva Meta
          </button>
        </div>
      </div>

      {/* Estadísticas Dashboard */}
      {estadisticas && vista === 'dashboard' && (
        <>
          <div className="estadisticas-grid">
            <div className="stat-card blue">
              <div className="stat-icon">🎯</div>
              <div className="stat-content">
                <div className="stat-value">{estadisticas.metas_activas}</div>
                <div className="stat-label">Metas Activas</div>
              </div>
            </div>

            <div className="stat-card green">
              <div className="stat-icon">✅</div>
              <div className="stat-content">
                <div className="stat-value">{estadisticas.metas_cumplidas}</div>
                <div className="stat-label">Metas Cumplidas</div>
              </div>
            </div>

            <div className="stat-card orange">
              <div className="stat-icon">💰</div>
              <div className="stat-content">
                <div className="stat-value">${estadisticas.comisiones_pendientes?.toLocaleString()}</div>
                <div className="stat-label">Comisiones Pendientes</div>
              </div>
            </div>

            <div className="stat-card purple">
              <div className="stat-icon">💵</div>
              <div className="stat-content">
                <div className="stat-value">${estadisticas.comisiones_mes?.toLocaleString()}</div>
                <div className="stat-label">Pagado Este Mes</div>
              </div>
            </div>
          </div>

          {/* Ranking de Cobradores */}
          <div className="ranking-section">
            <h2>🏆 Ranking de Cumplimiento</h2>
            <div className="ranking-grid">
              {estadisticas.ranking && estadisticas.ranking.map((cobrador, index) => (
                <div key={index} className="ranking-card">
                  <div className="ranking-posicion">
                    {index === 0 && '🥇'}
                    {index === 1 && '🥈'}
                    {index === 2 && '🥉'}
                    {index > 2 && `#${index + 1}`}
                  </div>
                  <div className="ranking-info">
                    <strong>{cobrador.nombre_completo}</strong>
                    <div className="ranking-stats">
                      <span>{cobrador.total_metas} metas</span>
                      <span>{cobrador.metas_cumplidas} cumplidas</span>
                    </div>
                  </div>
                  <div className="ranking-porcentaje">
                    {cobrador.promedio_cumplimiento?.toFixed(1)}%
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Comisiones por Cobrador */}
          <div className="comisiones-section">
            <div className="section-header">
              <h2>💰 Comisiones del Mes</h2>
              <button className="btn-calcular" onClick={calcularComisiones}>
                🧮 Calcular Comisiones
              </button>
            </div>
            
            <div className="comisiones-grid">
              {estadisticas.comisiones_por_cobrador && estadisticas.comisiones_por_cobrador.map((cobrador, index) => (
                <div key={index} className="comision-card">
                  <div className="comision-cobrador">
                    <strong>{cobrador.nombre_completo}</strong>
                    <span className="comision-cantidad">{cobrador.cantidad} pagos</span>
                  </div>
                  <div className="comision-monto">
                    ${cobrador.total_comision?.toLocaleString()}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Vista de Tabs */}
      <div className="vista-tabs">
        <button 
          className={vista === 'dashboard' ? 'active' : ''}
          onClick={() => setVista('dashboard')}
        >
          📊 Dashboard
        </button>
        <button 
          className={vista === 'metas' ? 'active' : ''}
          onClick={() => setVista('metas')}
        >
          🎯 Metas ({metas.length})
        </button>
        <button 
          className={vista === 'comisiones' ? 'active' : ''}
          onClick={() => setVista('comisiones')}
        >
          💰 Comisiones ({comisiones.length})
        </button>
      </div>

      {/* Lista de Metas */}
      {vista === 'metas' && (
        <div className="metas-container">
          {loading ? (
            <div className="loading">Cargando metas...</div>
          ) : metas.length === 0 ? (
            <div className="empty-state">
              <p>📭 No hay metas registradas</p>
              <button onClick={() => setMostrarModalMeta(true)}>
                Crear Primera Meta
              </button>
            </div>
          ) : (
            <div className="metas-grid">
              {metas.map(meta => (
                <div key={meta.id} className={`meta-card ${getEstadoClass(meta.estado)}`}>
                  <div className="meta-header">
                    <h3>{meta.cobrador_nombre}</h3>
                    <span className={`badge-tipo ${meta.tipo}`}>
                      {meta.tipo === 'diaria' && '📅'}
                      {meta.tipo === 'semanal' && '📆'}
                      {meta.tipo === 'mensual' && '📊'}
                      {' '}{meta.tipo}
                    </span>
                  </div>

                  <div className="meta-objetivo">
                    <div className="objetivo-item">
                      <label>Objetivo:</label>
                      <span className="valor-objetivo">${meta.monto_objetivo?.toLocaleString()}</span>
                    </div>
                    {meta.cantidad_cobros_objetivo && (
                      <div className="objetivo-item">
                        <label>Cobros objetivo:</label>
                        <span>{meta.cantidad_cobros_objetivo}</span>
                      </div>
                    )}
                  </div>

                  <div className="meta-progreso">
                    <div className="progreso-header">
                      <span>Alcanzado: ${meta.monto_alcanzado?.toLocaleString()}</span>
                      <span className="porcentaje">{meta.porcentaje_cumplimiento?.toFixed(1)}%</span>
                    </div>
                    <div className="progreso-bar">
                      <div 
                        className="progreso-fill"
                        style={{ 
                          width: `${Math.min(meta.porcentaje_cumplimiento, 100)}%`,
                          backgroundColor: getProgresoColor(meta.porcentaje_cumplimiento)
                        }}
                      ></div>
                    </div>
                    <div className="progreso-stats">
                      <span>{meta.cantidad_cobros_realizados} cobros realizados</span>
                    </div>
                  </div>

                  <div className="meta-periodo">
                    <span>📅 {meta.periodo_inicio}</span>
                    {meta.periodo_fin && <span> → {meta.periodo_fin}</span>}
                  </div>

                  {meta.bono_cumplimiento && (
                    <div className="meta-bono">
                      🎁 Bono: ${meta.bono_cumplimiento?.toLocaleString()}
                    </div>
                  )}

                  <div className="meta-footer">
                    <span className={`estado-badge ${meta.estado}`}>
                      {meta.estado === 'activa' && '🟢 Activa'}
                      {meta.estado === 'cumplida' && '✅ Cumplida'}
                      {meta.estado === 'vencida' && '⏰ Vencida'}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Lista de Comisiones */}
      {vista === 'comisiones' && (
        <div className="comisiones-container">
          <div className="comisiones-header">
            <h2>💰 Historial de Comisiones</h2>
            <div className="filtros-comisiones">
              <button className="btn-filtro active">Todas</button>
              <button className="btn-filtro">Pendientes</button>
              <button className="btn-filtro">Pagadas</button>
            </div>
          </div>

          {comisiones.length === 0 ? (
            <div className="empty-state">
              <p>📭 No hay comisiones registradas</p>
              <button onClick={calcularComisiones}>
                Calcular Comisiones
              </button>
            </div>
          ) : (
            <div className="comisiones-table">
              <table>
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Cobrador</th>
                    <th>Concepto</th>
                    <th>Base</th>
                    <th>%</th>
                    <th>Comisión</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {comisiones.map(comision => (
                    <tr key={comision.id}>
                      <td>{new Date(comision.created_at).toLocaleDateString()}</td>
                      <td>{comision.cobrador_nombre}</td>
                      <td className="concepto-cell">{comision.concepto}</td>
                      <td>${comision.monto_base?.toLocaleString()}</td>
                      <td>{comision.porcentaje}%</td>
                      <td className="monto-comision">
                        ${comision.monto_comision?.toLocaleString()}
                      </td>
                      <td>
                        <span className={`estado-badge ${comision.estado}`}>
                          {comision.estado === 'pendiente' && '⏳ Pendiente'}
                          {comision.estado === 'pagada' && '✅ Pagada'}
                          {comision.estado === 'cancelada' && '❌ Cancelada'}
                        </span>
                      </td>
                      <td>
                        {comision.estado === 'pendiente' && (
                          <button
                            className="btn-pagar-comision"
                            onClick={() => pagarComision(comision.id)}
                          >
                            💵 Pagar
                          </button>
                        )}
                        {comision.estado === 'pagada' && comision.fecha_pago && (
                          <span className="fecha-pago">
                            {new Date(comision.fecha_pago).toLocaleDateString()}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Modal Nueva Meta */}
      {mostrarModalMeta && (
        <>
          <div className="modal-backdrop" onClick={() => setMostrarModalMeta(false)}></div>
          <div className="modal-nueva-meta">
            <div className="modal-header">
              <h3>🎯 Nueva Meta</h3>
              <button className="btn-close" onClick={() => setMostrarModalMeta(false)}>×</button>
            </div>

            <form onSubmit={crearMeta} className="form-nueva-meta">
              <div className="form-group">
                <label>Cobrador *</label>
                <select
                  value={nuevaMeta.cobrador_id}
                  onChange={e => setNuevaMeta({...nuevaMeta, cobrador_id: e.target.value})}
                  required
                >
                  <option value="">Seleccionar cobrador...</option>
                  {cobradores.map(cobrador => (
                    <option key={cobrador.id} value={cobrador.id}>
                      {cobrador.nombre_completo}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Tipo de Meta *</label>
                  <select
                    value={nuevaMeta.tipo}
                    onChange={e => setNuevaMeta({...nuevaMeta, tipo: e.target.value})}
                    required
                  >
                    <option value="diaria">📅 Diaria</option>
                    <option value="semanal">📆 Semanal</option>
                    <option value="mensual">📊 Mensual</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Fecha Inicio *</label>
                  <input
                    type="date"
                    value={nuevaMeta.periodo_inicio}
                    onChange={e => setNuevaMeta({...nuevaMeta, periodo_inicio: e.target.value})}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Monto Objetivo (RD$) *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={nuevaMeta.monto_objetivo}
                    onChange={e => setNuevaMeta({...nuevaMeta, monto_objetivo: e.target.value})}
                    required
                    placeholder="15000"
                  />
                </div>

                <div className="form-group">
                  <label>Cantidad de Cobros</label>
                  <input
                    type="number"
                    value={nuevaMeta.cantidad_cobros_objetivo}
                    onChange={e => setNuevaMeta({...nuevaMeta, cantidad_cobros_objetivo: e.target.value})}
                    placeholder="20"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Bono por Cumplimiento (RD$)</label>
                <input
                  type="number"
                  step="0.01"
                  value={nuevaMeta.bono_cumplimiento}
                  onChange={e => setNuevaMeta({...nuevaMeta, bono_cumplimiento: e.target.value})}
                  placeholder="500"
                />
              </div>

              <div className="modal-actions">
                <button type="button" onClick={() => setMostrarModalMeta(false)}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  Crear Meta
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </div>
  );
};

export default MetasComisiones;

